module.exports = {"431222102":"麻溪铺镇","431222105":"五强溪镇","431222110":"明溪口镇","431222111":"凉水井镇","431222112":"七甲坪镇","431222113":"筲箕湾镇","431222114":"官庄镇","431222115":"沅陵镇","431222223":"杜家坪乡","431222224":"楠木铺乡","431222230":"肖家桥乡","431222234":"火场土家族乡","431222238":"陈家滩乡","431222239":"清浪乡","431222245":"借母溪乡","431222247":"荔溪乡","431222248":"大合坪乡","431222250":"马底驿乡","431222251":"北溶乡","431222252":"二酉乡","431222253":"盘古乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431222.json
// module id = 1919
// module chunks = 0